{
  "version": 1,
  "asset_id": "fdcd427f-614e-4b52-abcd-c11a7348cd24",
  "project_id": "734c54a9-ffec-4c25-9063-92ce0fc791b9",
  "url": "/__l5e/assets-v1/fdcd427f-614e-4b52-abcd-c11a7348cd24/retatrutide-vorher-nachher-4-wochen.jpg",
  "r2_key": "a/v1/734c54a9-ffec-4c25-9063-92ce0fc791b9/fdcd427f-614e-4b52-abcd-c11a7348cd24/retatrutide-vorher-nachher-4-wochen.jpg",
  "original_filename": "retatrutide-vorher-nachher-4-wochen.jpg",
  "size": 90608,
  "content_type": "image/jpeg",
  "created_at": "2026-07-10T12:03:22Z"
}
